import './ccf-filter-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfFilterIconProps extends SvgIconProps  {}

/**
 * CcfFilterIcon used to disply filter icon in the contact card history panel
 * @param props - CcfFilterIconProps
 * @example -- <CcfFilterIcon />
 */
export function CcfFilterIcon(props: CcfFilterIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Filter" clipPath="url(#clip-Filter)">
        <path id="Path_13215" data-name="Path 13215" d="M8.25,15h3V13.5h-3ZM3,6V7.5H16.5V6Zm2.25,5.25h9V9.75h-9Z" transform="translate(2.25 1.5)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfFilterIcon;
